module.exports = __webpack_public_path__ + "sunsemweb/img/code1.59aadc19.png";